const isTouchScreen =
  navigator.maxTouchPoints || 'ontouchstart' in document.documentElement;

export const environment = {
  version: require('../../package.json').version,
  production: true,
  useMock: false,
  baseApiUrl: 'https://gatewaywebapi.organic-alliance.com/api/WebAppExtClient',
  baseAvailabilityApiUrl: 'https://gatewaywebapi2.organic-alliance.com/api/WebAppExtClient',
  baseFileUrl: 'https://extranet.organic-alliance.com/_BusinessWebApi',
  languages: ['fr-FR', 'en-US', 'es-ES'],
  defaultColor: '#3A7E45',
  defaultLogoUrl:
    'https://extranet.organic-alliance.com/_BusinessWebApi/Data/COMMON/logoOA_vecto.png',

  sizeXS: 480,
  sizeSM: 600,
  sizeMD: 720,
  sizeLG: 960,
  sizeXL: 1280,

  offset: 160,

  appUserAgent: 'OrganicApp',
  isTouchScreen: isTouchScreen,
  isMobile: isTouchScreen && screen.width <= 960,

  noOrderErrorCode: 'NO_ORDER',

  availableLimits: [20, 50, 100, 200],

  cssVarsOptions: {
    onlyLegacy: !/Edge\/1[56]\./i.test(navigator.userAgent),
  },
};
